export enum TasksActionPoint {
  Save = 1,
  Checkmark = 2,
  ApproveTask = 3,
}
